import { render, staticRenderFns } from "./PeriodShiftIncGrid.vue?vue&type=template&id=1141993f"
import script from "./PeriodShiftIncGrid.vue?vue&type=script&lang=js"
export * from "./PeriodShiftIncGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports